module.exports = __webpack_public_path__ + "static/media/pizza-milano.bbcdaea1.png";